import React from 'react';

import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import Typography from '@latitude/typography';

export const slugifyTitle = title =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const mapFaqModal = item => ({
  id: slugifyTitle(item.title),
  title: item.title,
  content: item.content
});

const RATE_COLOR_BY_LOAN_ID = {
  fixed: '#0555c8',
  variable: '#006AFF'
};

const ACCORDION_PROPS_BY_LOAN_ID = {
  fixed: {
    contentBgColor: '#E6E6E6',
    titleBgColor: '#F2F2F2'
  },
  variable: {}
};

export const resolveLoanColumn = (
  column,
  {
    fixedComparisonRateFrom,
    fixedComparisonRateTo,
    variableComparisonRateFrom,
    variableComparisonRateTo,
    establishmentFee,
    LoanDetailsComponent
  }
) => ({
  ...column,
  comparisonRateFrom:
    column.comparisonRateFrom ||
    (column.id === 'fixed'
      ? fixedComparisonRateFrom
      : variableComparisonRateFrom),
  comparisonRateTo:
    column.comparisonRateTo ||
    (column.id === 'fixed' ? fixedComparisonRateTo : variableComparisonRateTo),
  rateColor: RATE_COLOR_BY_LOAN_ID[column.id] || REBRAND_COLOR.MID_BLUE,
  accordionProps: ACCORDION_PROPS_BY_LOAN_ID[column.id] || {},
  accordionItems: buildAccordionItems(
    column.accordionItemsData,
    establishmentFee,
    LoanDetailsComponent
  ),
  accordionItemsVariable: buildAccordionItems(
    column.accordionItemsVariableData || column.accordionItemsData,
    establishmentFee,
    LoanDetailsComponent
  )
});

export const buildAccordionItems = (
  itemsData = [],
  establishmentFee,
  LoanDetailsComponent
) =>
  itemsData.map(item => ({
    id: item.id || item.accordionButtonId || item.title,
    title: item.title,
    content: (
      <LoanDetailsComponent>
        {(Array.isArray(item.content) ? item.content : []).map(
          (contentItem, index) => (
            <Typography.Body
              key={`${
                item.id || item.accordionButtonId || item.title
              }-${index}`}
              color={contentItem.color}
            >
              {contentItem.text === '__ESTABLISHMENT_FEE__'
                ? establishmentFee
                : contentItem.text}
            </Typography.Body>
          )
        )}
      </LoanDetailsComponent>
    )
  }));
